<!--
tabela GRUTRIB, REGRAIMP, GRUTRIBNCM

cg/grutrib/
cg/grutrib/:id

BO_CG.POST_GRUTRIB
BO_CG.DELETE_GRUTRIB

 -->

<template>
  <div>
    <!-- <div v-if="!adicionaRegraShow"> -->
    <div>
      <bar-manut single-entity="Grupo de Regra de Imposto" :crud="this.crud" :btn-delete="true"
        v-on:closeform="handleCloseForm" v-on:save="handleSave(true)" v-on:delete="apiDelete()">
      </bar-manut>

      <!-- FORMULARIO PRINCIPAL DAS REGRAS -->
      <div class="default-container">
        <div class="row">
          <form-field v-model="grutrib.codgrutrib" type="text" col="2" :metadata="metadata.grutrib.codgrutrib" disabled>
          </form-field>
          <form-field ref="descricao" v-model="grutrib.descricao" type="text" col="4"
            :metadata="metadata.grutrib.descricao" max-length="40"></form-field>
          <form-field v-model="grutrib.regra_geral" type="select" col="2" :metadata="metadata.grutrib.regra_geral">
          </form-field>
        </div>

        <!-- CONTADORES DE REGRAS -->
        <div class="row nb-margin-bottom nb-margin-top">
          <div class="col-md-12">
            <strong
              v-if="(grutrib.regra_geral != 'S') && ((grutribncmList.length == 0) || (grutribitemList.length == 0))"
              class="badge badge-danger">Nenhuma NCM ou Produto foi relacionado a este grupo</strong>
            <strong v-if="regraimpList.length > 0" class="lbl badge badge-green data-list">{{ countRegrasValidas }}
              Regras
              válidas</strong>
            <strong v-if="regraimpList.length > 0" class="lbl badge badge-gray data-list">{{ countRegrasDesativadas }}
              Regras desativadas</strong>
            <strong v-if="regraimpList.length > 0" class="lbl badge badge-gray data-list">{{ countRegrasVencidas }}
              Regras
              vencidas</strong>
            <strong v-if="grutribncmList.length > 0" class="lbl badge badge-green data-list">{{ grutribncmList.length }}
              NCM´s relacionadas</strong>
            <strong v-if="grutribitemList.length > 0" class="lbl badge badge-green data-list">{{ grutribitemList.length
            }}
              Produto´s relacionados</strong>
          </div>
        </div>

        <br>


        <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>


        <!-- LISTA DE REGRAS -->
        <div v-show="activeTab == 2" class="mt-3">
          <div v-if="regraimpList.length == 0">
            <alert type="warning" title="Informações Importantes"
              text="O grupo de NCM´s envolve o relacionamento das regras de impostos e vários NCM´s com as mesmas características.
                                    Efetue a inclusão das regras para cada estado e finalidade através do botão abaixo, e depois relacione os NCM´s a este grupo através da guia 'NCM´s Relacionadas'.">
            </alert>
          </div>
          <div>
            <!-- <div class="card-header">Filtros</div> -->
            <div>
              <div class="row justify-content-center">
                <div class="col-md-6 col-3">
                  <v-button label="Adicionar Regras a Este Grupo" title="" icon="fa-plus" :nb-btdef="true"
                    @click="handleAdicionaRegra"></v-button>
                </div>
                <form-field v-if="regraimpList.length > 0" v-model="filtroEstado" type="select" col="3"
                  :select-options="filtroEstadosList" label=""></form-field>
                <form-field v-if="regraimpList.length > 0" v-model="filtroFinalidade" type="select" col="3"
                  :select-options="filtroFinalidadesList" label=""></form-field>
                <div class="col-md-2">
                  <!-- <v-button label="Remover Filtros" @click="removerFiltros"></v-button> -->
                </div>
              </div>
            </div>
          </div>

          <div v-for="(estado, index) in distinctEstadosList" :key="index"
            if="(estado.ufdest==filtroEstado || filtroEstado == '*')">
            <div class="row nb-margin-top nb-margin-bottom">
              <div class="col-md-12 col-12">
                <v-label label="Estade de Destino"></v-label><br>
                <span class="lbl-title-produto">{{ estado.ufdest }}</span><br>
              </div>
            </div>
            <div v-for="(regraimp, index) in regraimpList" :key="index" style="padding-left: 30px">
              <div class="mainbox"
                v-if="(estado.ufdest == regraimp.ufdest) && (filtroFinalidade == '*' || regraimp.finalidade == filtroFinalidade)">
                <div
                  :class="[{ 'mark-red': (regraimp.stregraimp === 'I' || regraimp.duplicate || regraimp.validate) }, { 'mark-green': (regraimp.stregraimp === 'A') }]">
                </div>
                <div class="box">
                  <div class="col" v-if="regraimp.validate">
                    <div class="alert alert-warning fade show" role="alert">
                      <span> <strong>Erro de validação:</strong> {{ regraimp.validate }} </span>
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-2 col-3">
                      <v-label label="Código da Regra"></v-label><br>
                      <span class="lbl">{{ regraimp.codregraimp }}</span>
                    </div>
                    <div class="col-md-2 col-3" v-if="regraimp.grucli && regraimp.grucli.legnth > 0">
                      <v-label label="Tipo/Finalidade"></v-label><br>
                      <span class="lbl">{{ regraimp.grucli[0].descricao }}</span>
                    </div>
                    <div class="col-md-2 col-3">
                      <v-label label="Tipo/Finalidade"></v-label><br>
                      <span class="lbl">{{ textFinalidade(regraimp.finalidade) }}</span>
                    </div>
                    <div class="col-md-2 col-3">
                      <v-label label="Data de Início"></v-label><br>
                      <span class="lbl">{{ formatDate(regraimp.dtinicio) }}</span>
                    </div>
                    <div class="col-md-2 col-3">
                      <v-label label="Data de Validade"></v-label><br>
                      <span class="lbl">{{ formatDate(regraimp.dtfim) }}</span>
                    </div>

                    <div class="col-md-12 col-12">
                      <a style="cursor: pointer; color: #0091ea;" data-toggle="collapse"
                        :data-target="'#detalheRegra' + index" aria-expanded="false"
                        :aria-controls="'detalheRegra' + index">Detalhar</a>
                      <!-- <v-button v-show="!visualizaRegra(regraimp.codregraimp)" label="Ver detalhes da regra" icon="fa-eye" @click="openRegra(regraimp)"></v-button> -->
                    </div>

                    <div class="col-md-12 col-12">
                      <span class="badge badge-danger" v-if="regraimp.stregraimp == 'I'">Regra desativada</span>
                      <span class="lbl badge badge-orange" v-if="regraimp.vencida == 'S'">Regra com validade
                        vencida</span>
                      <span class="lbl badge badge-gray" v-if="regraimp.foraperiodo == 'N'">Regra fora do período</span>
                    </div>
                  </div>
                  <br>
                  <!-- <div class="row align-items-center collapse" :id="'detalheRegra' + index" v-show="visualizaRegra(regraimp.codregraimp)"> -->
                  <div class="row align-items-center collapse" :id="'detalheRegra' + index">
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.aicminterno" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.aicminterno" :precision="2"
                      name="aicminterno" :v-errors="errors" v-validate="metadata.regraimp.aicminterno.validator">
                    </form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.aicmexterno" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.aicmexterno" :precision="2"
                      name="aicmexterno" :v-errors="errors" v-validate="metadata.regraimp.aicmexterno.validator">
                    </form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.ricm" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.ricm" :precision="2"
                      name="ricm" :v-errors="errors" v-validate="metadata.regraimp.ricm.validator"></form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.mva" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.mva" :precision="2" name="mva"
                      :v-errors="errors" v-validate="metadata.regraimp.mva.validator"></form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.mvaorig" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.mvaorig" :precision="2"
                      name="mvaorig" :v-errors="errors" v-validate="metadata.regraimp.mvaorig.validator"></form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.aicmst" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.aicmst" :precision="2"
                      name="aicmst" :v-errors="errors" v-validate="metadata.regraimp.aicmst.validator"></form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.pautaicmst" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.pautaicmst" :precision="2"
                      name="pautaicmst" :v-errors="errors" v-validate="metadata.regraimp.pautaicmst.validator">
                    </form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.ricmst" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.ricmst" :precision="2"
                      name="ricmst" :v-errors="errors" v-validate="metadata.regraimp.ricmst.validator"></form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.afcpst" type="value" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.afcpst" :precision="2"
                      name="afcpst" :v-errors="errors" v-validate="metadata.regraimp.afcpst.validator"></form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.cfop" type="select2" col="6"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.cfop"
                      :select2="{ entity: 'cfop/saidas', minlength: 0 }"></form-field>

                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.sticm" type="select2" col="6"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.sticm"
                      :select2="{ entity: 'tabpadval/11', minlength: 0 }"></form-field>

                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.csosn" type="select2" col="6"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.csosn"
                      :select2="{ entity: 'tabpadval/7', minlength: 0 }"></form-field>


                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.bcdifalnovo" type="select" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.bcdifalnovo"></form-field>
                    <form-field v-if="grutrib.regra_geral != 'S'" v-model="regraimp.optsimples" type="select" col="2"
                      :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.optsimples"></form-field>
                    <form-field v-if="grutrib.regra_geral == 'S'" v-model="regraimp.tipo_calc_difal" type="select"
                      col="2" :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.tipo_calc_difal">
                    </form-field>
                    <div class="col-md-3 col-4">
                      <input-switch type="success" label="Regra Ativa" v-model="regraimp.stregraimp" value-checked="A"
                        value-unchecked="I" :metadata="regraimp.stregraimp"></input-switch>
                    </div>
                    <div class="col-md-4 col-6">
                      <v-button label="Salvar" :nb-btdef="true" @click="handleSave(false)"></v-button>
                      <v-button label="Cancelar" data-toggle="collapse" :data-target="'#detalheRegra' + index"
                        aria-expanded="false" :aria-controls="'detalheRegra' + index"></v-button>
                      <!-- <v-button label="Cancelar" @click="openRegra(regraimp)"></v-button> -->
                    </div>
                    <!-- <form-field v-model="regraimp.stregraimp" type="select" col="2"
                                            :metadata="metadata.regraimp.stregraimp"></form-field> -->
                  </div>
                </div>
                <br>
              </div>
            </div>
          </div>

        </div> <!-- lista de regras -->


        <!-- LISTA DE NCMs -->
        <div v-show="activeTab == 0">
          <div v-if="regraimpList.length == 0">
            <alert type="warning" title="Adicionar NCM´s"
              text="Adicione vários NCM´s com caracterísitcas semelhantes ao grupo de NCM´s. Os NCM´s informados aqui compartilharão das mesmas regras e não poderão ser adicionados à outros grupos de NCM.">
            </alert>
          </div>
          <div class="mainbox-select" v-for="(grutribncm, index) in grutribncmList" :key="index"
            style="background-color: #eee">
            <div :class="[{ 'mark-red': grutribncm.duplicate || grutribncm.validate }]"></div>
            <div class="box">
              <div class="col" v-if="grutribncm.duplicate">
                <span class="error">NCM Duplicado</span>
              </div>
              <div class="col" v-if="grutribncm.validate">
                <span class="error"> {{ grutribncm.validate }} </span>
              </div>
              <div class="row align-items-center">
                <form-field ref="ncm" v-model="grutribncm.ncm" type="select2" col="6"
                  :metadata="metadata.grutribncm.ncm" :select2="{ entity: 'ncm', minlength: 1 }"></form-field>
                <form-field v-model="grutribncm.exncm" type="number" col="2" :metadata="metadata.grutribncm.exncm">
                </form-field>
                <div class="col-md-2 col-2">
                  <v-button label="" title="Excluir NCM" icon="fa-trash" @click="handleDeleteNCM(index)"></v-button>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-12 col-12">
              <v-button label="Adicionar NCM a Este Grupo" title="" icon="fa-plus" :nb-btdef="true"
                @click="handleAdicionaNCM"></v-button>
              <v-button v-if="grutribncmList.length > 0" label="Adicionar Regras a Este Grupo" title="" icon="fa-plus"
                :nb-btdef="true" @click="handleAdicionaRegra"></v-button>
            </div>
          </div>
        </div>



        <!-- LISTA DE PRODUTOS -->
        <div v-show="activeTab == 1">
          <div v-if="regraimpList.length == 0">
            <alert type="warning" title="Adicionar Produtos"
              text="Adicione vários produtos com caracterísitcas semelhantes ao grupo de NCM´s. Os NCM´s informados aqui compartilharão das mesmas regras e não poderão ser adicionados à outros grupos de NCM.">
            </alert>
          </div>
          <div class="mainbox-select" v-for="(grutribitem, index) in grutribitemList" :key="index"
            style="background-color: #eee">
            <div :class="[{ 'mark-red': grutribitem.duplicate || grutribitem.validate }]"></div>
            <div class="box">
              <div class="col" v-if="grutribitem.duplicate">
                <span class="error">Produto Duplicado</span>
              </div>
              <div class="col" v-if="grutribitem.validate">
                <span class="error"> {{ grutribitem.validate }} </span>
              </div>
              <div class="row align-items-center">
                <form-field ref="item" v-model="grutribitem.coditem" type="select2" col="6"
                  :metadata="metadata.grutribitem.coditem" :select2="{ entity: 'item', minlength: 2 }"></form-field>
                <div class="col-md-2 col-2">
                  <v-button label="" title="Excluir Item" icon="fa-trash" @click="handleDeleteProduto(index)">
                  </v-button>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-12 col-12">
              <v-button label="Adicionar Produto" title="" icon="fa-plus" :nb-btdef="true"
                @click="handleAdicionaProduto"></v-button>
              <v-button v-if="grutribitemList.length > 0" label="Adicionar Regras a Este Grupo" title="" icon="fa-plus"
                :nb-btdef="true" @click="handleAdicionaRegra"></v-button>
            </div>
          </div>
        </div>

      </div>

    </div>

    <transition name="fade">
      <regraimp-add v-if="adicionaRegraShow" :grutrib="grutrib" crud="ins" @save="handleSaveRegras"
        @closeform="closeFormAdicionaRegra"></regraimp-add>
    </transition>

    <vue-snotify></vue-snotify>

    <md-message v-if="showMessage" :code="codeMessage" @close="closeMessage()" @confirm="handleConfirmMessage()">
    </md-message>

  </div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDS, apiORDSdelete } from '../shared/api-functions'
import regraimpAdd from './regraimp-add-form'
import { formatDate } from '../shared/utils';

export default {
  props: {
    crud: '',
    codgrutrib: '',
  },

  components: {
    regraimpAdd
  },

  data() {
    return {
      crudText: '',

      metadata: this.$store.getters.getEntities.metadata,
      regraimp: { ...this.$store.getters.getEntities.regraimp },
      grutrib: { ...this.$store.getters.getEntities.grutrib },

      lFinalidade: '',
      lUfori: '',
      lNcm: '',

      regraimpList: [],  //array de regras de impostos (tabela regraimp)
      grutribncmList: [], //lista de ncms do grupo de tributacao (tabela grutribncm)
      grutribitemList: [], //lista de produtos do grupo de tributacao (tabela grutribitem)
      estadoList: [],
      controleVisualizacao: [],

      adicionaRegraShow: false,

      showMessage: false,
      message: '',
      showError: false,
      unwatch: false,

      filtroEstado: '*',
      filtroFinalidade: '*',

      tabs: [
        { title: 'NCMs Vinculadas ao Grupo' },
        { title: 'Produtos Vinculados' },
        { title: 'Regras Vinculadas ao Grupo' }
      ],
      activeTab: 0, //pagina ativa

      close: false,

    }
  },

  computed: {
    countRegrasValidas: function () {
      return this.regraimpList.filter(x => x.stregraimp != 'I' && x.vencida != 'S').length
    },
    countRegrasVencidas: function () {
      return this.regraimpList.filter(x => x.vencida === 'S').length
    },
    countRegrasDesativadas: function () {
      return this.regraimpList.filter(x => x.stregraimp === 'I').length
    },
    filtroEstadosList: function () {
      const distinctEstados = [...new Set(this.regraimpList.map(obj => obj.ufdest))]
      let list = distinctEstados.map(function (value) {
        return { id: value, text: value }
      })
      list.unshift({ id: '*', text: 'Estado (Todos)' })
      return list
    },
    filtroFinalidadesList: function () {
      let vm = this
      const distinct = [...new Set(this.regraimpList.map(obj => obj.finalidade))]
      let list = distinct.map(function (value) {
        return { id: value, text: vm.textFinalidade(value) }
      })
      list.unshift({ id: '*', text: 'Finalidade (Todas)' })
      return list
    },
    distinctEstadosList: function () {
      const distinctEstados = [...new Set(this.regraimpList.map(obj => obj.ufdest))]
      let list = distinctEstados.map(function (value) {
        return { ufdest: value }
      })
      if (this.filtroEstado == '*') {
        return list
      } else {
        return list.filter(obj => obj.ufdest === this.filtroEstado)
      }
    },
  },

  watch: {
    grutribncmList: {
      handler: function (val, oldval) {
        if (this.unwatch) {
          return
        }
        this.ncmCheck()
      },
      deep: true
    },

    filtroFinalidade: function (val) {
      // console.log(val)
    },

    filtroEstado: function (val) {
      // console.log(val)
    }
  },

  filter: {
  },

  methods: {
    removerFiltros() {
      this.filtroEstado = '*'
      this.filtroFinalidade = '*'
    },

    textFinalidade(value) {
      if (this.metadata) {
        var item = this.metadata.regraimp.finalidade.options.filter(x => x.id === value);
        if (item.length > 0) { return item[0].text }
      } else {
        return value
      }
    },

    formatDate(value) {
      return formatDate(value)
    },

    visualizaRegra(codregraimp) {
      return this.controleVisualizacao.indexOf(codregraimp) >= 0
    },

    openRegra(regra) {
      let x = this.controleVisualizacao.indexOf(regra.codregraimp)
      if (x >= 0) {
        this.controleVisualizacao.splice(x, 1)
      } else {
        this.controleVisualizacao.push(regra.codregraimp)
      }
    },

    closeForm() {
      this.$emit('closeform')
    },

    handleCloseForm() {
      if (this.changed) {                     // se ocorreu alguma alteração exibe mensagem antes de fechar
        this.showMessageModal('closeform')
      } else {
        this.closeForm()
      }
    },

    changeTab(idx) {
      //mudança de pagina
      this.activeTab = idx
    },

    handleConfirmMessage() {
      //EVENTO DO BOTAO "CONFIRMAR" DA MENSAGEM
      if (this.codeMessage == 'closeform') { //fecha o formulario e retornar para o anterior
        this.closeMessage()
        this.closeForm()
      }
    },

    showMessageModal(code) {
      //exibe uma mensagem em "code"
      this.codeMessage = code
      this.showMessage = true
    },

    closeMessage() {
      this.showMessage = false
    },

    closeFormAdicionaRegra() {
      //FECHA O FORMULARIO DE INCLUSAO DE REGRAS
      this.adicionaRegraShow = false
    },

    handleAdicionaRegra() {
      //ABRE TELA PARA INCLUSAO DE CONJUNTO DE REGRAS
      if (this.grutrib.descricao == '' || this.grutrib.descricao == null) {
        this.$erpToastError('É necessário o preenchimento da descrição do grupo.')
        this.$nextTick(function () {
          this.$refs.descricao.focus()
        })
        return
      }
      this.grutrib.grutribncm = this.grutribncmList
      this.adicionaRegraShow = true
    },

    handleAdicionaNCM() {
      //adiciona nova linha na lsita de ncms
      var ncm = { ...this.$store.getters.getEntities.grutribncm }
      this.unwatch = true
      this.grutribncmList.push(ncm);
      this.unwatch = false
      this.$nextTick(function () {
        this.$refs.ncm[this.grutribncmList.length - 1].focus()
      })
    },

    handleDeleteNCM(index) {
      //exclui uma ncm da lista
      this.grutribncmList.splice(index, 1)
    },

    handleAdicionaProduto() {
      //adiciona nova linha na lsita de ncms
      var item = { ...this.$store.getters.getEntities.grutribitem }
      this.unwatch = true
      this.grutribitemList.push(item);
      this.unwatch = false
      this.$nextTick(function () {
        this.$refs.item[this.grutribitemList.length - 1].focus()
      })
    },

    handleDeleteProduto(index) {
      //exclui um produto da lista
      this.grutribitemList.splice(index, 1)
    },

    handleSaveRegras(grutrib) {
      //APOS CONFIRMAR A INCLUSAO DE NOVAS REGRAS, CARREGA O OBJETO ATUALIZAOD PARA TELA
      this.grutrib = grutrib
      this.regraimpList = this.grutrib.regraimp
      this.grutribncmList = this.grutrib.grutribncm
      this.grutribitemList = this.grutrib.grutribitem
      this.removerFiltros
      this.closeFormAdicionaRegra()
    },

    handleSave(close) {
      //BOTAO SALVAR
      //EFETUA VALIDACAO DE PREENCHIMENTO DAS REGRAS

      this.close = close

      let lErro = false
      let validate = ''

      for (var x = 0; x < this.regraimpList.length; x++) {
        validate = ''
        this.regraimpList[x].valid = (this.regraimpList[x].finalidade != null && this.regraimpList[x].ufdest != null)

        if (this.regraimpList[x].stregraimp != 'I') {
          if (this.regraimpList[x].finalidade != null && this.regraimpList[x].ufdest == null) {
            validate = 'O campo ' + this.metadata.regraimp.ufdest.label + ' é obrigatório'
          }
          if (this.regraimpList[x].finalidade == null && this.regraimpList[x].ufdest != null) {
            validate = 'O campo ' + this.metadata.regraimp.finalidade.label + ' é obrigatório'
          }
        }
        if (this.regraimpList[x].finalidade != null && this.regraimpList[x].ufdest != null && this.regraimpList[x].stregraimp != 'I') {
          if (this.regraimpList[x].aicmexterno > 99) {
            validate = 'O valor informado é inválido: ' + this.metadata.regraimp.aicmexterno.label
          } else
            if (this.regraimpList[x].aicminterno > 99) {
              validate = 'O valor informado é inválido: ' + this.metadata.regraimp.aicminterno.label
            } else
              if (this.regraimpList[x].mva > 99) {
                validate = 'O valor informado é inválido: ' + this.metadata.regraimp.mva.label
              } else
                if (this.regraimpList[x].mvaorig > 99) {
                  validate = 'O valor informado é inválido: ' + this.metadata.regraimp.mvaorig.label
                } else
                  if (this.regraimpList[x].aicmst > 99) {
                    validate = 'O valor informado é inválido: ' + this.metadata.regraimp.aicmst.label
                  } else
                    if (this.regraimpList[x].ricmst > 99) {
                      validate = 'O valor informado é inválido: ' + this.metadata.regraimp.ricmst.label
                    } else
                      if (this.regraimpList[x].ricm > 99) {
                        validate = 'O valor informado é inválido: ' + this.metadata.regraimp.ricm.label
                        //comentado para permitir o cálculo do diferencial de alíquota
                        // } else
                        // if (this.regraimpList[x].aicmst > 0) {
                        //     if (this.regraimpList[x].mva == null || this.regraimpList[x].mva == 0) {
                        //         if (this.regraimpList[x].pautaicmst == null || this.regraimpList[x].pautaicmst == 0) {
                        //             validate = 'Obrigatório informar '  + this.metadata.regraimp.mva.label + ' ou '  + this.metadata.regraimp.pautaicm.label
                        //         }
                        //     }
                      }
        }
        if (validate.length > 0) {
          lErro = true
          this.$set(this.regraimpList[x], 'validate', validate)
          this.regraimpList[x].valid = false
        } else {
          this.$set(this.regraimpList[x], 'validate', '')
        }
      }

      if (lErro) {
        this.$erpToastError('Por favor corrija os erros de validação nas regras em destaque.')
        return false
      }

      //AQUI EFETUA VALIDACAO DE DUPLICIDADE NAS REGRAS E NOS NCMS
      for (var x = 0; x < this.grutribncmList.length; x++) {
        if (this.grutribncmList[x].validate || this.grutribncmList[x].duplicate) {
          lErro = true
        }
      }

      if (lErro) {
        lErro = true
        this.activeTab = 0   //habilita a pagina de ncms
        this.$erpToastError('Por favor corrija os NCM´s duplicados.')
        return false
      }

      for (var x = 0; x < this.grutribitemList.length; x++) {
        if (this.grutribitemList[x].validate || this.grutribitemList[x].duplicate) {
          lErro = true
        }
      }

      if (lErro) {
        lErro = true
        this.activeTab = 0   //habilita a pagina de ncms e produtos
        this.$erpToastError('Por favor corrija os produtos duplicados.')
        return false
      }

      let lErro2 = this.regraCheckDuplicate()
      if (lErro2) {
        lErro = true
        this.activeTab = 1   //habilita a pagina regras
        this.$erpToastError('Por favor corrija as regras duplicadas.')
      }

      if (lErro) {
        return false
      }


      if (this.grutrib.regra_geral != 'S' && this.grutribncmList.length == 0 && this.grutribitemList.length == 0) {
        this.$erpToastError('Adicione um NCM ou Produto para continuar.');
        return false
      }

      if (this.grutrib.regra_geral == 'S' && this.grutribncmList.length > 0) {
        this.$erpToastError('Grupo de regra marcado como Geral não pode possuir NCMs Vinculados.');
        return false
      }

      if (this.grutrib.regra_geral == 'S' && this.grutribitemList.length > 0) {
        this.$erpToastError('Grupo de regra marcado como Geral não pode possuir Produtos Vinculados.');
        return false
      }

      this.apiPost()

    },

    async loadEstados() {
      //carrega lista de estados cadastrados
      await this.$store.dispatch('loadEstadoRegras')
      if (this.$store.getters.getEstadoList) {
        this.estadoList = this.$store.getters.getEstadoList.map(function (obj) {
          return { id: obj.uf, text: obj.uf }
        })
      }

      if (this.crud == SysVars.crudU) {
        this.loadData()
      } else {
        this.regraimpList = []
      }


    },

    async loadData() {
      this.unwatch = true
      let params = { id: this.codgrutrib }
      await this.$store.dispatch('loadGrutrib', params)
      if (this.$store.getters.getGrutrib) {
        //carrega os objetos grutrib, grutrib.regraimp, grutrib.grutribncm
        this.grutrib = this.$store.getters.getGrutrib
        this.regraimpList = this.grutrib.regraimp
        this.grutribncmList = this.grutrib.grutribncm
        this.grutribitemList = this.grutrib.grutribitem
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
      this.unwatch = false
    },


    // getInput().then(value => alert(value));

    // async ncmCheck2 () {
    //     return new Promise(resolve => {
    //         let ncm = false
    //         for (var x = 0; x < this.grutribncmList.length; x++) {
    //             this.$set(this.grutribncmList[x], 'validate', '')
    //             let url = this.$store.getters.urlOrds + 'cg/grutrib/ncm/' + this.grutribncmList[x].ncm
    //             const data = await apiORDS(url, {})
    //             console.log(data)
    //             if (data.items && data.items.length > 0) {
    //                 if (data.items[0].codgrutrib != this.grutrib.codgrutrib) {
    //                     this.grutribncmList[x].validate = 'Este NCM já foi associado ao grupo: ' + data.items[0] + ' e não poderá ser associado a outro grupo.'
    //                     ncm = true
    //                 }
    //             }
    //         }
    //         resolve(ncm)
    //     })
    // },

    async ncmCheck() {

      this.unwatch = true

      let ncm = false
      for (var x = 0; x < this.grutribncmList.length; x++) {
        if (!this.grutribncmList[x].validate) {
          this.$set(this.grutribncmList[x], 'validate', '')
        }
        if (this.grutribncmList[x].ncm == '') {
          continue
        }
        let url = this.$store.getters.urlOrds + 'cg/grutrib/ncm/' + this.grutribncmList[x].ncm
        const data = await apiORDS(url, {})
        if (data.items && data.items.length > 0) {
          if (data.items[0].codgrutrib != this.grutrib.codgrutrib) {
            this.unwatch = true
            this.grutribncmList[x].validate = 'Este NCM já foi associado ao grupo: ' + data.items[0].descricao + ' e não poderá ser associado a outro grupo.'
            ncm = true
          } else {
            this.grutribncmList[x].validate = ''
          }
        }
        else {
          this.grutribncmList[x].validate = ''
        }
      }

      //checa se foi digitado algum NCM/EXNCM duplicado para o grupo de tributacao
      let test = {}
      //cria novo objeto array para fazer a verificacao de duplicidades
      let ncmArr = this.grutribncmList.map(function (obj) {
        return { ncm: obj.ncm, exncm: obj.exncm }
      })
      //efetua a verificacao da duplicidade
      let duplicate = false
      for (var x = 0; x < ncmArr.length; x++) {
        test = ncmArr[x]
        if (!this.grutribncmList[x].duplicate) {
          this.$set(this.grutribncmList[x], 'duplicate', false)
        }
        if (ncmArr.findIndex(obj => obj.ncm === test.ncm && obj.exncm === test.exncm) < x) {
          this.grutribncmList[x].duplicate = true
          duplicate = true
        } else {
          this.grutribncmList[x].duplicate = false
        }
      }

      this.unwatch = false
    },

    regraCheckDuplicate() {
      //checa se foi digitado alguma regra duplicado para o grupo de tributacao, pesquisando no array regraList
      //considerando como chave os campos UFDEST, FINALIDADE, ORIMERC, CODGRUCLI

      let test = {}
      //cria novo objeto array para fazer a veiricacao de duplicidades
      let arrRegra = this.regraimpList.map(function (obj) {
        return {
          ufdest: obj.ufdest,
          dtinicio: obj.dtinicio,
          finalidade: obj.finalidade,
          orimerc: obj.orimerc,
          codgrucli: obj.codgrucli,
          stregraimp: obj.stregraimp
        }
      })
      //efetua a verificacao da duplicidade (uf destino, finalidade, origem, data de inicio e grupo de cliente)
      let duplicate = false
      let i = 0
      for (var x = 0; x < arrRegra.length; x++) {
        this.$set(this.regraimpList[x], 'duplicate', false)
        if (arrRegra[x].stregraimp == 'I') {
          continue
        }
        console.log(arrRegra[x].codregraimp)
        test = arrRegra[x]
        if (test.ufdest != null && test.finalidade != null) {
          i = (arrRegra.findIndex(obj => obj.ufdest == test.ufdest && obj.finalidade == test.finalidade &&
            obj.orimerc == test.orimerc && obj.dtinicio == test.dtinicio && obj.codgrucli == test.codgrucli))
          if (i < x && arrRegra[i].stregraimp != 'I') {
            this.regraimpList[x].duplicate = true
            this.regraimpList[x].validate = 'Duplicidade de regra'
            duplicate = true
          }
        }
      }
      return duplicate
    },

    async apiDelete() {
      //efetua a exclusao do grupo de tributacao

      var modulo = 'cg/grutrib/' + this.grutrib.codgrutrib
      var sendData = {}

      const data = await apiORDSdelete(this.$store, modulo)
      this.$erpToastSuccess('O grupo de tributação foi excluído')
      this.closeForm()
    },

    async apiPost() {
      //efetua a gravacao das regras

      var modulo = 'cg/grutrib/'
      var sendData = {}
      var regraimpValid = []

      for (var x = 0; x < this.regraimpList.length; x++) {
        if (this.regraimpList[x].valid) {
          regraimpValid.push(this.regraimpList[x])
        }
      }


      var grutribitem = []
      for (var x = 0; x < this.grutribitemList.length; x++) {
        if (this.grutribitemList[x].coditem) {
          grutribitem.push(this.grutribitemList[x])
        }
      }

      sendData = { grutrib: this.grutrib }
      sendData.grutrib.regraimp = regraimpValid
      sendData.grutrib.grutribncm = this.grutribncmList
      sendData.grutrib.grutribitem = grutribitem

      var metodo = 'post'

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      this.$erpToastSuccess('As regras foram gravadas com sucesso')
      if (this.close) {
        this.closeForm()
      }
    },

  },

  created() {
    this.loadEstados()

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
      this.$refs.descricao.focus()
    })

  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/regraimp-form.vue